import React from "react";

function ComingSoonDivider({ visible }) {
  return (
    <div
      className="grid cs1 ce12 mt-32 mb-32"
      style={{
        display: visible ? "grid" : "none",
      }}>
      <hr className="hr cs1 ce3"></hr>
      <h4 className="h4 cs4 ce8 align-center softer-help">
        More tools <br /> on the way
      </h4>
      <hr className="hr cs9 ce12"></hr>
    </div>
  );
}

export default ComingSoonDivider;
